import request from "../../../Service/api_client";

function coachSearch(formData) {
  return request({
    url: "/searches",
    method: "POST",
    data: formData,
  });
}
function coachCombineSearch(formData) {
  return request({
    url: "/searches/combined_search",
    method: "POST",
    data: formData,
  });
}
function addSelectedCoaches(formData) {
  return request({
    url: "/searches/add_selected_coaches",
    method: "POST",
    data: formData,
  });
}

function getSelectedCoaches(formData) {
  return request({
    url: "/searches/selected_coaches",
    method: "GET",
    params: formData,
  });
}

function removeSelectedCoaches(formData) {
  return request({
    url: "/searches/remove_coaches",
    method: "DELETE",
    data: formData,
  });
}
function emailSelectedCoaches(formData) {
  return request({
    url: "/searches/selected_coaches_email",
    method: "Post",
    data: formData,
  });
}

function saveSelectedCoaches(formData) {
  return request({
    url: "/shortlisting_coaches/longlist_formation",
    method: "POST",
    data: formData,
  });
}

const CoachService = {
  coachSearch,
  addSelectedCoaches,
  getSelectedCoaches,
  removeSelectedCoaches,
  emailSelectedCoaches,
  coachCombineSearch,
  saveSelectedCoaches,
};

export default CoachService;
